<template>
  <div>
    <p v-translate>You are about to reinstate this submission, which will supersede (replace) any previous version.</p>
    <p v-translate>Press OK to continue.</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  }
}
</script>

